var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 32,
    height: 32,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAaVBMVEUAAADg/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43g/43///9JjlBsAAAAIXRSTlMAEiYuDiQpKwcDolDgezDi/W5AFDiax3jAKE6l+eQKufSA2d8aAAAAAWJLR0QiXWVcrAAAAAd0SU1FB+cEDgoiH/XnnmoAAACtSURBVDjL1dLZFoIgFIXho5iFQyqOmWb7/V+yFM2Jw337jvV/C24gIscVeh6Nu/jrrv6NZIBl4QQibCcohhXcKUGaKb18AsV8UqW+AajIuBoLaNheWsDYa8WDqRMPdOfB3FmwdA78OgPWbgabbgTbTkUUPQ5g1/V2oD33PZDPUz88IVuyA8NsIA9DzwqU7cP8F+jQvziQAS4NQN+YV6WAQ+INy4LvPWLouJzEkj4PXiowrw0ChAAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirect);
export default __webpack_public_path__ + "static/media/direct.a92fb4e154bf98ca563e19b1f1721b2d.svg";
export { ForwardRef as ReactComponent };